import { VisualizerDataSource } from "@/shared/services";

/**
 * Resolve the single org that owns the visualizer's data sources, or
 * `undefined` when the sources span zero or more than one org.
 *
 * The visualizer is the only multi-resource view, so it collapses its own
 * cross-org ambiguity here — at registration — and reports a single org or
 * none. Every other view owns at most one record and reports that record's org
 * directly, which keeps the service's `getViewingOrgId` a uniform dedupe over
 * each part's `orgId`.
 */
export function singleOrgIdForDataSources(
  dataSources: VisualizerDataSource[],
): string | undefined {
  const orgIds = new Set<string>();
  for (const source of dataSources) {
    if (source.record?.org_id) {
      orgIds.add(source.record.org_id);
    }
  }
  return orgIds.size === 1 ? [...orgIds][0] : undefined;
}
